import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControllerButtonX: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="controller-button-x, dismiss, close, cancel, delete, remove"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconControllerButtonX;
